var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "output" }, [
    _c("iframe", { attrs: { srcdoc: _vm.code } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }